import React from 'react';
import PropTypes from 'prop-types';
import { ConditionalLink, Component } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import moment from 'moment';

import { isInternalURL } from '@plone/volto/helpers/Url/Url';

const SummaryTemplate = ({ items, linkTitle, linkHref, isEditMode }) => {
  let link = null;
  let href = linkHref?.[0]?.['@id'] || '';

  if (isInternalURL(href)) {
    link = (
      <ConditionalLink to={flattenToAppURL(href)} condition={!isEditMode}>
        {linkTitle || href}
      </ConditionalLink>
    );
  } else if (href) {
    link = <a href={href}>{linkTitle || href}</a>;
  }

  return (
    <>
      <div className="items">
        {items.map((item) => (
          <div className="listing-item" key={item['@id']}>
           
              <Component componentName="PreviewImage" item={item} alt="" />
              <div className="listing-body" data-patata={item.href}>
                <h3><ConditionalLink item={item} condition={!isEditMode} className="stretched-link" >{item.title || item.id}</ConditionalLink></h3>
                {item?.description && ( <p>{item.description}</p> )}
                {item['@type']==="Event" && (
                  <time className='fs-sm' dateTime={moment(item.start).format('YYYY-MM-DD')} >{moment(item.start).format('DD/MM/YYYY - hh:mm')}</time>
                )}
              </div>
            
          </div>
        ))}
      </div>

      {link && <div className="footer">{link}</div>}
    </>
  );
};

SummaryTemplate.propTypes = {
  items: PropTypes.arrayOf(PropTypes.any).isRequired,
  linkMore: PropTypes.any,
  isEditMode: PropTypes.bool,
};

export default SummaryTemplate;
